export default "<a href=\"javascript:;\" class=\"primary-white\" [class.disabled]=\"isDisabled=='true'\" (click)=\"onBtnClick()\" translate>{{btnLabel}}</a>";